/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
requirejs.config({
  paths: {
    'jquery': 'lib/jquery-1.11.1.min',
  }
});

define(
  ['ext','./core/Util',
    './core/EventManager', './core/UIBuilder', './core/Config'],
  (Ext, util, eventManager, uiBuilder, config) => {
    'use strict';
    // Extjs is using the `window` global for dynamic function eval
    // Look at: /home/adel/projects/playground/migtowebpack/node_modules/extjs/build/ext-all-debug.js:1821
    // needed for webpack
    // TODO: we can move this to index.js ? 
    window.Ext = window.Ext || Ext; 
    function init(customView) {
        	if (customView) {
        		Core.View = customView;
        	} /*else {
        		Core.View = new View();
        		Core.View.init();
        	}*/
    }
        
    const coreConfig = new config(eventManager);
    coreConfig.init();
        
    const Core = {
      Util: util,
      View: null,
      EventManager: eventManager,
      UIBuilder: uiBuilder,
      Config: coreConfig,
            
      init: init
    };
        
    return Core;
  }
);
